module.exports = __webpack_public_path__ + "static/media/ic_general_truck_gray.42622301.svg";